import styled, { keyframes, css } from 'styled-components';

const tvkBreathe = keyframes`
  0%, 100% { transform: scale(1); opacity: .5; }
  50% { transform: scale(1.08); opacity: .85; }
`;

const tvkPulse = keyframes`
  0% { stroke-dashoffset: 0; opacity: 0; }
  12% { opacity: 1; }
  88% { opacity: 1; }
  100% { stroke-dashoffset: -240; opacity: 0; }
`;

const reducedMotionStop = css`
  @media (prefers-reduced-motion: reduce) {
    animation-play-state: paused !important;
  }
`;

export const Stage = styled.div`
  position: relative;
  width: 640px;
  height: 640px;
  flex-shrink: 0;
`;

export const HubGlow = styled.div`
  position: absolute;
  left: 170px;
  top: 170px;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(242, 105, 31, 0.3) 0%, rgba(242, 105, 31, 0) 70%);
  animation: ${tvkBreathe} 6s ease-in-out infinite;
  ${reducedMotionStop}
`;

export const SvgLayer = styled.svg`
  position: absolute;
  inset: 0;
  width: 640px;
  height: 640px;
  overflow: visible;
`;

export const PulseGroup = styled.g<{ $playState: 'running' | 'paused' }>`
  fill: none;
  stroke: #f2691f;
  stroke-width: 4.5;
  stroke-linecap: round;
  stroke-dasharray: 18 240;
  animation-play-state: ${({ $playState }) => $playState};

  line {
    animation: ${tvkPulse} 2.6s linear infinite;
    animation-play-state: inherit;
  }

  @media (prefers-reduced-motion: reduce) {
    animation-play-state: paused !important;
    line {
      animation-play-state: paused !important;
    }
  }
`;

export const HubTileImg = styled.img`
  position: absolute;
  left: 250px;
  top: 256.5px;
  width: 140px;
  height: 127px;
  object-fit: contain;
  filter: drop-shadow(0 20px 18px rgba(198, 67, 4, 0.42));
  pointer-events: none;
`;

export const OSBadge = styled.div`
  position: absolute;
  left: 360px;
  top: 353.5px;
  width: 58px;
  height: 58px;
  border-radius: 27%;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 27, 45, 0.18);
  pointer-events: none;
`;

export const ModuleNode = styled.div`
  position: absolute;
  width: 108px;
  height: 108px;
  border-radius: 50%;
  background: #ffffff;
  border: 2.5px solid rgba(242, 105, 31, 0.34);
  box-shadow: 0 9px 20px rgba(15, 27, 45, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  transition: transform 0.15s, box-shadow 0.15s, border-color 0.15s;
`;

export const ModuleLabel = styled.div`
  font-family: 'Archivo', 'Inter', sans-serif;
  font-size: 12.5px;
  font-weight: 700;
  color: #0f1b2d;
  text-align: center;
  line-height: 1.25;
`;
